<template>
  <div style="width: 100%; text-align: center;">
    <h2 style="text-align: center;margin: 10px 0">培训申请表</h2>
    <table style="border: 2px black solid;width: 45%;height:1000px;margin: 0 auto" >
      <div>
        <div class="head">
            <tr style="height: 80px">
              <td style="text-align: center;line-height: 30px;width: 16.7%">姓名</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%"><input class="input" value=""></td>
              <td style="text-align: center;line-height: 30px;width: 16.7%">部门</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%"><input class="input" value="软件工程学院"></td>
              <td style="text-align: center;line-height: 30px;width: 16.7%">职务/岗位</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%"><input class="input" value="总经理"></td>
            </tr>
            <tr style="height: 80px">
              <td style="text-align: center;line-height: 30px;width: 16.7%">学历</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%"><input class="input" value="本科"></td>
              <td style="text-align: center;line-height: 30px;width: 16.7%">进公司时间</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%;" colspan="3"><input class="input">20年10月10日</td>
            </tr>
            <tr style="height: 80px">
              <td style="text-align: center;line-height: 30px;width: 16.7%">培训形式</td>
              <td style="text-align: center;line-height: 30px;width: 33.3%" colspan="3"><input type="checkbox">脱产<input type="checkbox">半脱产 <input type="checkbox">业余</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%">培训费用</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%"><input class="input" value="10192元"></td>
            </tr>
            <tr style="height: 80px">
              <td style="text-align: center;line-height: 30px;width: 16.7%">培训地点</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%" colspan="2"><input class="input-2" value="金陵科技学院"></td>
              <td style="text-align: center;line-height: 30px;width: 16.7%">培训还能起止时间</td>
              <td style="text-align: center;line-height: 30px;width: 16.7%" colspan="2"><input class="input-2" value="2020.10.10-2022.10.10"></td>
            </tr>
        </div>

      </div>
      <div >
        <tr style="height: 90px;">
        <td>内容</td>
        <td colspan="5" style="padding: 0px">
          <div style="height: 5px;"></div>
          <div style="text-align: left;">培训机构:<input class="input-3" value="     软件工程培训z班"></div>
          <div style="text-align: left">培训种类:(注明具体培训名称)</div>
          <div  style="width: 100%;">
            <div style="text-align:left;margin: 8px 10px">技术等级培训: <input class="input-3" value="开发工程师甲级"></div>
            <div style="text-align:left;margin: 8px 10px">执业资格培训: <input class="input-3" value="开发工程师执业资格证"></div>
            <div style="text-align:left;margin: 8px 10px">职称考前培训: <input class="input-3" value="无"></div>
            <div style="text-align:left;margin: 8px 10px">业务培训: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input class="input-3" value="开发,测试,架构"></div>
            <div style="text-align:left;margin: 8px 10px">继续教育: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input class="input-3" value="可以继续教育"></div>
            <div style="text-align:left;margin: 8px 10px">技术等级培训: <input class="input-3" value="A级"></div>
          </div>
        </td>
        </tr>
        <tr style="height: 90px;">
          <td>申请理由</td>
          <td colspan="5">
            <div style="height: 100px;padding: 2px" ><input style="border: 0px;height: 80px;width: 99%" value=" 在学习上，始终以学习为主，立足专业，认真学习本专业相关知识，
          "></div>

            <div style="padding-right: 100px; text-align: right;">申请人: <input style="border: 0px;height:30px" value=""></div>
            <div style="padding-right: 100px; text-align: right;">日期: <input style="border: 0px;height:30px" value="2022-11-23"></div>

          </td>
        </tr>
      </div>
      <div>
        <tr style="height: 90px;">
        <td rowspan="2">参训前审核
        </td>
        <td colspan="5">
          <div style="padding: 20px;text-align: left">部门负责人意见:</div>
          <div style="height: 100px;padding: 2px" ><input style="border: 0px;height: 80px;width: 99%" value="          该同学情况属性,同意!"></div>

          <div style="padding-right: 100px; text-align: right;">申请人: <input style="border: 0px;height:30px" value=""></div>
          <div style="padding-right: 100px; text-align: right;">日期: <input style="border: 0px;height:30px" value="2022-11-23"></div>
        </td>
        </tr>
        <tr style="height:90px;">
        <td colspan="5">
          <div style="text-align: left;padding: 5px">人力资源部负责人意见:</div>
          <div style="text-align: left;padding: 5px"><input type="checkbox">已签订培训协议</div>
          <div style="text-align: left;padding: 5px"><input type="checkbox">无需签订培训协议</div>

          <div style="padding-right: 100px; text-align: right;">申请人: <input style="border: 0px;height:30px" value=""></div>
          <div style="padding-right: 100px; text-align: right;">日期: <input style="border: 0px;height:30px" value="2022-11-23"></div>
        </td>
        </tr>
      </div>
    </table>
  </div>

</template>

<script>
export default {
  name: "trainingApplication"
}
</script>

<style lang="less">
td{
  border: 1px black solid;
}
.head{
  //给td一个类无效
  //.head-row{
  //  height: 40px;
  //}

}
.input{
  border: 0px;
  height: 90%;
}
.input-2{
  border: 0px;
  height: 94%;
  width: 97%;
}
.input-3{
  border: 0px;
  height: 20px;
  width: 70%;
}
</style>